export default "__VITE_ASSET__e$RWsPBf__"